import type { Ref } from 'vue';

import { onScopeDispose } from 'vue';

import { OUTSIDE_CLICK_LISTENER_DELAY_MS } from '@/composables/booking/booking-widget.constants';

export type UseDropdownOptions = {
  isOpen: Ref<boolean>;
  dropdownRef: Ref<HTMLElement | undefined>;
  isMobile: Ref<boolean>;
  onOpen?: () => void;
  onClose?: () => void;
};

export function useDropdown(options: UseDropdownOptions) {
  const { isOpen, dropdownRef, isMobile, onOpen, onClose } = options;

  function handleOutsideClick(event: Event) {
    const path = event.composedPath();
    const target = path[0];
    if (dropdownRef.value && !dropdownRef.value.contains(target as Node)) {
      closeDropdown();
    }
  }

  function openDropdown() {
    if (isOpen.value) {
      closeDropdown();
      return;
    }
    isOpen.value = true;
    onOpen?.();

    setTimeout(() => {
      if (isOpen.value && !isMobile.value) {
        document.addEventListener('click', handleOutsideClick);
      }
    }, OUTSIDE_CLICK_LISTENER_DELAY_MS);
  }

  function closeDropdown() {
    isOpen.value = false;
    if (!isMobile.value) {
      document.removeEventListener('click', handleOutsideClick);
    }
    onClose?.();
  }

  onScopeDispose(() => {
    document.removeEventListener('click', handleOutsideClick);
  });

  return {
    openDropdown,
    closeDropdown,
    handleOutsideClick,
  };
}
